<script setup lang="ts">
import type { ComboboxSeparatorProps } from "./combobox.types";
import { useComboboxSeparator } from "./useCombobox.Separator";

defineOptions({ name: "ComboboxSeparator" });

const props = withDefaults(defineProps<ComboboxSeparatorProps>(), {
  decorative: true,
});

const { classes } = useComboboxSeparator({ props });
</script>

<template>
  <div
    part="separator"
    :class="classes"
    class="e-combobox-separator"
    :role="decorative ? 'none' : 'separator'"
    :aria-orientation="decorative ? undefined : 'horizontal'"
  />
</template>

<style>
:host {
  display: contents;
}
</style>
